import { TEST_IDS } from '@va/constants';
import { CampaignsIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { UrlPatternType, UrlPatternTypeEnum } from '@va/types/website';
import { getUrlPatternDropdownOptions, IconWithBackground, SelectDropdownInput } from '@va/ui/design-system';
import React from 'react';

type UrlPatternItemProps = {
  urlPattern: UrlPatternType;
  clearSelectedUrlPattern: (urlPattern: UrlPatternType) => void;
  onUrlPatternChange: (value: string, urlPatternId: string) => void;
  disabled?: boolean;
};

export const UrlPatternItem: React.FC<UrlPatternItemProps> = ({
  urlPattern,
  clearSelectedUrlPattern,
  onUrlPatternChange,
  disabled,
}) => {
  const translate = useTranslate();

  const urlPatternOptions = getUrlPatternDropdownOptions(translate);

  return (
    <div>
      <SelectDropdownInput
        disabled={disabled}
        className='rounded-none! rounded-t-12!'
        title={translate('moduleSettings.recordings.urlPatterns.title')}
        subtitle={translate('moduleSettings.recordings.urlPatterns.subtitle')}
        options={urlPatternOptions}
        selectedOption={{
          value: '',
          label: translate(getUrlPatternTranslationKey(urlPattern.type)),
          icon: (
            <IconWithBackground
              className='bg-white-snow! group-hover:bg-white!'
              icon={() => <CampaignsIcon color='white' />}
            />
          ),
        }}
        clearSelectedOption={() => {
          clearSelectedUrlPattern(urlPattern);
        }}
        onChange={() => {}}
        icon={<IconWithBackground className='bg-green-pure!' icon={() => <CampaignsIcon color='white' />} />}
        data-testid={TEST_IDS.specific.recordingsSettingsTab.recordSpecificPages.selectUrlPatternDropdown}
      />
      <input
        disabled={disabled}
        value={urlPattern.url}
        onChange={(e) => {
          onUrlPatternChange(e.target.value, urlPattern.id);
        }}
        className='w-full bg-white p-15px text-12 rounded-b-12 text-gray-devil placeholder-gray-devil'
        placeholder={translate('moduleSettings.recordings.urlPatterns.placeholder')}
      />
    </div>
  );
};

function getUrlPatternTranslationKey(type: UrlPatternTypeEnum) {
  switch (type) {
    case UrlPatternTypeEnum.simple:
      return 'urlMatch.simple';
    case UrlPatternTypeEnum.exact:
      return 'urlMatch.exact';
    case UrlPatternTypeEnum.ends:
      return 'urlMatch.endsWith';
    case UrlPatternTypeEnum.starts:
      return 'urlMatch.startsWith';
    case UrlPatternTypeEnum.contains:
      return 'urlMatch.contains';
    default:
      return 'urlMatch.simple';
  }
}
